import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    private token: string;

    constructor(private authService: AuthService, @Inject('Window') private _window: Window) { }

    canActivate(route: ActivatedRouteSnapshot) {
        let param = this._window.location.search.substr(1);

        if (param.indexOf("error") >= 0) {
            this.authService.errorLogin();
            return false
        }
        this.token = this.authService.getTokenFromURL(param, route);
        const accessModel: Observable<boolean> = this.authService.validateAccessModel();

        if (!accessModel) {
            if (!this.token) {
                this.authService.authenticateOnOpenId();
                return false;
            }
            return this.authService.createAccessModel(this.token);
        }
        return true;
    }
}